export const SUPPORTED_SCHEDULE_LANGUAGES = [
	{
		code: 'en-US',
		label: 'English',
		nativeLabel: 'English',
	},
	{
		code: 'es-419',
		label: 'Spanish (Latin America)',
		nativeLabel: 'Español Latinoamérica',
	},
] as const

export type ScheduleLanguageCode = 'en-US' | 'es-419'

export const DEFAULT_SCHEDULE_LANGUAGE: ScheduleLanguageCode = 'en-US'
